import React, { useEffect, useState, useRef } from "react";

import { gsap } from "gsap";

import "./Hero.scss";

import LayeredImage from "../../components/shared/LayeredImage";
import Button from "../../components/shared/Button";
import SpeedBadge from "../../components/Home/SpeedBadge";
import BadgeChip from "../../components/Home/BadgeChip";

import hero_character from "../../assets/videos/hero-character.webm";
import hero_character_mov from "../../assets/videos/hero-character.mov";
import hero_character_mp4 from "../../assets/videos/hero-character.mp4";

import ImgLightHero from "../../assets/images/light-hero.svg";
import ImgHeroCloud1 from "../../assets/images/hero-cloud-1.svg";
import ImgHeroCloud2 from "../../assets/images/hero-cloud-2.svg";

import ImgMagicIcon from "../../assets/images/magic-icon.png";
import ImgP2PIcon from "../../assets/images/p2p-icon.png";
import ImgShieldIcon from "../../assets/images/shield-icon.png";
import ImgChatIcon from "../../assets/images/chat-icon.png";

export default function Hero() {
	const [isSafari, setIsSafari] = useState(false);
	const stormTextRef = useRef(null);

	useEffect(() => {
		const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(
			navigator.userAgent
		);
		setIsSafari(isSafariBrowser);

		if (stormTextRef.current) {
			gsap.to(stormTextRef.current, {
				duration: 2,
				scrambleText: {
					text: "Storm",
					chars: "abcdefghijklmnopqrstuvwxyz",
					speed: 0.3,
				},
				ease: "none",
			});
		}
	}, []);
	return (
		<>
			<div className="hero">
				<div className="hero-content-wrapper content-wrapper-lg">
					<div className="hero-content">
						<h1 className="hero-title">
							<span className="highlight" ref={stormTextRef}>
								Storm
							</span>{" "}
							the
							<br />
							Chain. Leave
							<br />
							No
							<SpeedBadge />
							Trace
						</h1>

						<div className="hero-btns">
							<Button href="https://syntraa.gitbook.io/storm" className="hero-btn">Get Started!</Button>
						</div>
					</div>

					<LayeredImage
						className="hero-image"
						width={520}
						height={520}
					>
						<img
							src={ImgLightHero}
							alt="Light Hero"
							className="light-hero"
						/>

						<img
							src={ImgHeroCloud1}
							alt="Cloud 1"
							className="hero-cloud-1"
						/>

						<BadgeChip className="hero-chip p2p-chip levitate-slow-1">
							<img
								className="badge-chip-icon"
								src={ImgP2PIcon}
								alt="P2P Icon"
							/>
							Private P2P
						</BadgeChip>

						<BadgeChip className="hero-chip native-mixer-chip levitate-slow-2">
							<img
								className="badge-chip-icon"
								src={ImgMagicIcon}
								alt="Magic Icon"
							/>
							Native Mixer
						</BadgeChip>

						<img
							src={ImgHeroCloud2}
							alt="Cloud 2"
							className="hero-cloud-2"
						/>

						<video
							className="storm-hero"
							autoPlay
							loop
							muted
							playsInline
							key={isSafari ? "safari" : "other"}
							/* style={{ background: "red" }} */
						>
							{isSafari ? (
								<>
									{/* Order for Safari: MOV -> WebM -> MP4 */}
									<source
										src={hero_character_mov}
										type="video/quicktime"
									/>
									<source
										src={hero_character}
										type="video/webm"
									/>
									<source
										src={hero_character_mp4}
										type="video/mp4"
									/>
								</>
							) : (
								<>
									{/* Order for other browsers: WebM -> MP4 */}
									<source
										src={hero_character}
										type="video/webm"
									/>
									<source
										src={hero_character_mp4}
										type="video/mp4"
									/>
								</>
							)}
							Your browser does not support the video tag.
						</video>

						<BadgeChip className="hero-chip storm-ai-chip levitate-slow-3">
							<img
								className="badge-chip-icon"
								src={ImgShieldIcon}
								alt="Shield Icon"
							/>
							StormAI
						</BadgeChip>

						<BadgeChip className="hero-chip promptify-chip levitate-slow-4">
							<img
								className="badge-chip-icon"
								src={ImgChatIcon}
								alt="Chat Icon"
							/>
							Promptify
						</BadgeChip>
					</LayeredImage>
				</div>
			</div>
		</>
	);
}
